import styled from 'styled-components'
import { IconButton } from 'ui/components/Buttons'

const DeleteButton = styled(IconButton)`
  margin-right: auto;
`

export const s = { DeleteButton }
